import React from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { Skeleton, Flex, Text } from 'uikit'
import { Farm } from 'state/types'
import Balance from 'components/Balance'
import LpTokenImage from 'components/LpTokenImage'

const FCard = styled.div`
  display: flex;
  border-radius: 12px 12px 0px 0px;
  font-weight: bold;
  line-height: 22px;
  color: #ffffff;
  font-size: 15px;
  padding: 14px 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 14px 36px;
  }

  @media screen and (min-width: 440px) {
    padding: 14px 36px;
  }
`

const Basic = styled.div`
  display: flex;
  flex: 4;
`

const No = styled.span`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    width: 20px;
  }
`

const Symbol = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    flex: 2;
  }
`

const Multiplier = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: flex;
    flex: 1;
  }
`

const APR = styled(Flex)`
  flex: 1;
`

const BalanceAPR = styled(Balance)`
  flex: 1;
  display: block;
  font-size: 15px;
  font-weight: bold;
`

const Liquidity = styled(Flex)`
  flex: 2;
`

const BalanceLiquidity = styled(Balance)`
  flex: 2;
  display: block;
  font-size: 15px;
  font-weight: bold;
`

export interface FarmWithStakedValue extends Farm {
  apr?: number
  lpRewardsApr?: number
  liquidity?: BigNumber
}

interface FarmItemProps {
  farm: FarmWithStakedValue
  no?: number
}

const FarmItem: React.FC<FarmItemProps> = ({ farm, no }) => {
  const symbol = farm.symbol && farm.symbol.split(' ')[0].toUpperCase()
  return (
    <FCard>
      <Basic>
        <No>{no}</No>
        <LpTokenImage token={farm.token} quoteToken={farm.quoteToken} height={22} />
        <Text fontSize="15px" fontWeight="bold" ml="4px">
          {symbol}
        </Text>
      </Basic>
      <Symbol>{symbol}</Symbol>
      {farm.multiplier ? (
        <Multiplier>{farm.multiplier}</Multiplier>
      ) : (
        <Multiplier>
          <Skeleton height={22} width={60} />
        </Multiplier>
      )}
      {farm.apr ? (
        <BalanceAPR textAlign="right" decimals={0} value={farm.apr} unit="%" />
      ) : (
        <APR justifyContent="end">
          <Skeleton height={22} width={60} />
        </APR>
      )}
      {farm.liquidity ? (
        <BalanceLiquidity textAlign="right" decimals={0} value={farm.liquidity.toNumber()} prefix="$" />
      ) : (
        <Liquidity justifyContent="end">
          <Skeleton height={22} width={60} />
        </Liquidity>
      )}
    </FCard>
  )
}

export default FarmItem
